export enum UserRole {
  BARBER = 'Barber',
  SHOP_BARBER = 'Shop Barber',
  SHOP_OWNER = 'Shop Owner',
}
